import dashboard from "./dashboard";
import clinicManagement from "./clinic-management";
import clinic from "./medical-operations";
import branchManagement from "./branch-management";
import payment from "./payment";

const menuItems = {
  items: [dashboard, clinic, payment,clinicManagement, branchManagement],
};

export default menuItems;
